import { IEngineSection } from '../schema/sections/IEngineSection';
import { IHydrationContext } from './IHydrationContext';
import { hydrateEngineSection } from './hydrateEngineSection';

/**
 * Si occupa di idratare l'albero dello schema, ovvero di ritornare l'intero
 * albero dei Widget in base ai _valori_ correnti del form e della sessione,
 * per side-effect.
 *
 * Attenzione! Questo vuol dire che _modifica_ i valori passati; non è un
 * problema sul server perché i dati terminano con la request
 *
 * È il parallello del rendering React, ma per le operazioni lato backend,
 * es. per la generazione dei PDF
 */
export function hydrateEngineValues(
  context: Pick<IHydrationContext, 'values' | 'validationContext' | 'omissis'>,
  sections: IEngineSection[],
) {
  return sections
    .map(section => hydrateEngineSection({ ...context, prefix: '' }, section))
    .filter(Boolean);
}
